export default __webpack_public_path__ + "static/media/ISCO CLASS-7 EXAM PATTERN 2025.25080aa6.pdf";